define([
    "dojo/_base/lang",
    "../../../constants/TypeConstants",
    "../properties/TypeProperty",
    "../properties/TagProperty",
    "../properties/EnabledProperty",
    "../properties/DescriptionProperty",
    "../properties/DescriptionOverrideProperty",
        "../properties/CompactProperty",
    "../properties/MnemonicProperty",
    "../properties/ShortcutProperty",
    "../properties/ActionIdProperty",
    "../properties/ItemsProperty",
    "../properties/ErrorTextProperty",
    "../properties/WarningTextProperty",
    "../properties/ValidationStateProperty"
],
    function (lang, TypeConstants, TypeProperty, TagProperty, EnabledProperty, DescriptionProperty, DescriptionOverrideProperty,
                CompactProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty, ItemsProperty, ErrorTextProperty, WarningTextProperty, ValidationStateProperty) {
        var hash = {};

        hash[TypeConstants.LIST] = lang.mixin({}, {
            selectedItems: {
                type: "Array",
                defaultValue: [],
                notInAction: false,
                required: false
            },
            selectionMode: {
                type: "string",
                defaultValue: "single",
                notInAction: false,
                required: false
            }
        }, TypeProperty, TagProperty, EnabledProperty, DescriptionProperty, DescriptionOverrideProperty, CompactProperty,
            MnemonicProperty, ShortcutProperty, ActionIdProperty, ItemsProperty, ErrorTextProperty, WarningTextProperty, ValidationStateProperty);

        return hash;
    });

